// Initialize infinite scrolling
// IN:
//UIT:
function initJsScroll() {

	$('.scroll_wrapper:last').jscroll({
		autoTrigger: true,
		padding: 2000,
		delay: 1000,
		nextSelector: '.jscroll-next:last',
		callback: newContentAdded
	});
}

// Called every time that a new session is added after scrolling the page
// IN:
//UIT:
function newContentAdded() {
	
	// insert tagmodule
	if ($('.listTags').length != 0) {
		$('.listTags').tagModule({'scriptLocation':'/autocomplete.php',
		                      'displayFunc' : displayTagLink,
		                      'removeTagHook' : removeTag,
		                      'spanTagClass' : 'list_item'});
	}
	
	var $lastSession = $('.jscroll-added').not(':has(.jscroll-loading)').last();

	collapseAllNewsItemsSession($lastSession,1000);
	
	handleMoreLessOption($lastSession.find('.collapseSections'));
	
	controlNewsWidth();
	attachClickFunction();
	
	//initialize embedded tweets
	twttr.widgets.load($lastSession);
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
